import { CETopicAttributesBase } from './ce-topic-attributes-base'


export class CETopicAttributes extends CETopicAttributesBase {

}